<template>
  <a @click.self="routeTo({ name: 'Product', params: { id: product.id }})"
     class="card" :class="{'grid-4': grid}">
    <div class="img_wrap_outer">
      <div class="img_wrap_inner" v-if="product.cache && product.cache.image && product.cache.image[225]">
        <img
            @click.self="routeTo({ name: 'Product', params: { id: product.id }})"
            :src="product.cache.image[225]" alt="product" class="active">
      </div>
      <div class="img_wrap_inner" v-else>
        <img
            @click.self="routeTo({ name: 'Product', params: { id: product.id }})"
            src="/images/no-img.svg" alt="product" class="active">
      </div>
      <span class="new_status" v-if="product.is_new">Новинка</span>
    </div>
    <div
        @click="routeTo({ name: 'Product', params: { id: product.id }})">
      <span class="code">{{ product.vendor_code }}</span>
      <span class="description">{{ product.name }}</span>
      <div class="price_wrap" v-if="show_price && product.cache && product.cache.retail_price">
        <span class="price">{{ product.cache.retail_price }} грн</span>
      </div>
      <div
        class="size_wrapper"
        v-if="show_price && product.cache.remains && product.cache.remains.length > 0"
      >
        <span
          :class="getColorRemainsForCard(size.remains)" v-for="(size, i) in product.cache.remains"
          :key="sliderKey+'product-size-'+i+size.size">
          {{ size.size }}
        </span>
      </div>
    </div>
  </a>
</template>

<script>

import { colors } from '../../mixins/colors'
import router from '../../router'

export default {
  name: 'TrendProductCard',
  inject: ['isAuth'],
  props: {
    show_price: {
      type: Boolean,
      default: false
    },
    grid: Boolean,
    product: {
      type: Object,
      default: () => {
        return {
          id: 0,
          name: '',
          cache: {}
        }
      }
    },
    sliderKey: {
      type: String,
      default: 'p-slider'
    }
  },
  mixins: [
    colors
  ],
  data () {
    return {
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        dots: true,
        arrows: false,
        autoplaySpeed: 6000,
        variableWidth: false,
        dotsClass: 'product-item-dot'
      }
    }
  },
  methods: {
    routeTo (route) {
      router.push(route)
    }
  }
}
</script>

<style scoped>

</style>
